export enum DocumentEntityTypeId {
  ClaimSet = 1,
  Claim = 2,
  Claimant = 13,
}
